"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.joinJsx = void 0;
const react_1 = __importDefault(require("react"));
/**
 * Joins an array of JSX elements together with a separator into one Fragment.
 * We need this because string.join() converts them all into strings but we need
 * the result to be a JSX.Element
 * @returns
 */
function joinJsx(array, separator) {
    const children = [];
    for (const elem of array) {
        if (children.length > 0) {
            children.push(separator);
        }
        children.push(elem);
    }
    return react_1.default.createElement(react_1.default.Fragment, null, ...children);
}
exports.joinJsx = joinJsx;
